// Maps a property/neighbourhood city or place name to one of the 5 CBC
// districts used in the Residential Property Price Index. Source key set
// matches the keys in src/data/cbc-rppi.json.
//
// District definitions follow CBC reporting (free Republic territory only):
//   nicosia   = Nicosia district  (Lefkosia city + surrounding suburbs)
//   limassol  = Limassol district (Lemesos city + surrounding coast/inland)
//   larnaca   = Larnaca district  (Larnaka city + surrounding)
//   paphos    = Paphos district   (Pafos city + Coral Bay + Polis + surrounding)
//   famagusta = Famagusta free area only (Ayia Napa + Protaras + Paralimni;
//               Famagusta city itself is in the occupied area and not covered)
const TABLE = {
  // Nicosia district
  nicosia: 'nicosia', lefkosia: 'nicosia', strovolos: 'nicosia',
  engomi: 'nicosia', aglantzia: 'nicosia', latsia: 'nicosia',
  geri: 'nicosia', lakatamia: 'nicosia', dali: 'nicosia',
  // Limassol district
  limassol: 'limassol', lemesos: 'limassol', germasogeia: 'limassol',
  'mesa geitonia': 'limassol', 'agios tychon': 'limassol',
  polemidia: 'limassol', 'kato polemidia': 'limassol',
  neapolis: 'limassol', pissouri: 'limassol', parekklisia: 'limassol',
  // Larnaca district
  larnaca: 'larnaca', larnaka: 'larnaca', mackenzie: 'larnaca',
  aradippou: 'larnaca', oroklini: 'larnaca', livadia: 'larnaca',
  finikoudes: 'larnaca', kiti: 'larnaca', dromolaxia: 'larnaca',
  // Paphos district
  paphos: 'paphos', pafos: 'paphos', 'kato paphos': 'paphos',
  'kato pafos': 'paphos', chloraka: 'paphos', peyia: 'paphos',
  'mesa chorio': 'paphos', 'coral bay': 'paphos', polis: 'paphos',
  emba: 'paphos',
  // Famagusta district (free area)
  'ayia napa': 'famagusta', protaras: 'famagusta',
  paralimni: 'famagusta', sotira: 'famagusta', deryneia: 'famagusta',
};

export function cityToDistrict(city) {
  if (!city || typeof city !== 'string') return null;
  return TABLE[city.trim().toLowerCase()] || null;
}

export const DISTRICT_LABEL = {
  nicosia:   'Nicosia',
  limassol:  'Limassol',
  larnaca:   'Larnaca',
  paphos:    'Paphos',
  famagusta: 'Famagusta',
};
